import { brandColors, hexToRgbA } from '@givebutter/util';
import { ZIndex } from 'components/util/ZIndex';
import { DefaultTheme, SizeObject } from 'styled-components';

const sizes = {
    fonts: {
        xs: '12px',
        sm: '13px',
        md: '15px',
        lg: '18px',
        xl: '20px',
        xxl: '24px',
        xxxl: '30px',
        huge: '40px',
    },
    spacers: {
        xxxs: '4px',
        xxs: '8px',
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '24px',
        xxl: '32px',
        xxxl: '40px',
        huge: '60px',
    },
    avatar: {
        sm: '24px',
        md: '32px',
        lg: '40px',
        xl: '48px',
    },
    button: {
        height: {
            sm: '32px',
            md: '40px',
            lg: '50px',
        },
        font: {
            sm: '12px',
            md: '16px',
            lg: '20px',
        },
    },
};

const typography = {
    font: 'Matter, sans-serif',
    body: {
        size: '14px',
        weight: '400',
        height: '15px',
    },
};

const radius = {
    default: '8px',
    large: '12px',
};

const shadows = {
    default: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    large: '0px 5px 30px rgba(0, 0, 0, 0.08)',
    popover: '0 -1px 20px rgba(0, 0, 0, 0.05), 0 1px 5px rgba(0, 0, 0, 0.15)',
    input: `0 0 0 2px ${hexToRgbA(brandColors.cobalt.primary, 0.07)}`,
};

const breakpoint = {
    mobile: '768px',
    tablet: '900px',
    laptop: '1100px',
    desktop: '1440px',
};

const utility = {
    transition: 'all cubic-bezier(0.16, 0.8, 0.45, 1) 0.3s',
    transform: 'transform cubic-bezier(0.16, 0.8, 0.45, 1) 0.2s',
};

const fontSize: SizeObject = {
    sm: '14px',
    md: '16px',
    lg: '18px',
};

const padding: SizeObject = {
    sm: '6px 14px',
    md: '8px 16px',
    lg: '10px 18px',
};

const gap: SizeObject = {
    sm: '8px',
    md: '10px',
    lg: '12px',
};

const useTheme = () => ({
    theme: {
        breakpoint,
        sizes,
        radius,
        shadows,
        utility,
        typography,
        zIndex: ZIndex,
        fontSize,
        padding,
        gap,
    } as DefaultTheme,
});

export { useTheme };
